import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { setToken } from '../lib/api';
import { useAuth } from '../context/AuthContext';

// Recibe el JWT emitido por el backend tras el login con Google, lo guarda y
// carga la sesión. REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR
// REDIRECT URLS, THIS BREAKS THE AUTH.
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (!token) {
      setError('No pudimos completar el inicio de sesión con Google.');
      setTimeout(() => navigate('/login?error=google'), 1500);
      return;
    }
    setToken(token);
    refresh().finally(() => navigate('/', { replace: true }));
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6" data-testid="auth-callback">
      {error ? (
        <p className="text-habita-dark font-medium">{error}</p>
      ) : (
        <>
          <Loader2 className="w-8 h-8 text-habita animate-spin" />
          <p className="mt-4 text-gray-600">Iniciando sesión con Google…</p>
        </>
      )}
    </div>
  );
}
